import * as React from "react";
import type { SVGProps } from "react";
const SvgVolume = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#volume_svg__a)">
      <path d="M15 16.93a1 1 0 0 1-.6-1.8c.3-.23.57-.5.8-.8a4 4 0 0 0-.8-5.6 1 1 0 1 1 1.2-1.6 6 6 0 0 1 0 9.6 1 1 0 0 1-.6.2" />
      <path d="M17.7 19.93a1 1 0 0 1-.96-.718 1 1 0 0 1 .34-1.062c.439-.36.835-.77 1.18-1.22a8 8 0 0 0-1.18-11.22 1.002 1.002 0 1 1 1.26-1.56 10 10 0 0 1 1.49 14.07 11 11 0 0 1-1.49 1.49 1 1 0 0 1-.64.22M10.21 20.86a1.82 1.82 0 0 1-1.55-.87l-3.15-4.06H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1.51l3.15-4A1.8 1.8 0 0 1 12 5.05v13.81a1.86 1.86 0 0 1-.32 1.25 1.8 1.8 0 0 1-1.17.73q-.15.025-.3.02M4 9.93v4h2a1 1 0 0 1 .79.39L10 18.44v-13l-3.21 4.1a1 1 0 0 1-.79.39z" />
    </g>
    <defs>
      <clipPath id="volume_svg__a">
        <path fill="#fff" d="M2 3h20.04v17.87H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVolume;
